<template>
    <transition @before-enter="beforeEnter" @enter="enter" @leave="leave" :css="false" appear>
        <section :class="this.name">
            <div class="bg"></div>
            <div class="content">
                <div class="cont">
                    <h2>스토리</h2>
                    <p>스로 창조주가 되고자 했던 거인들은 마침내 신에게 대항하기 위해서 막강한 전투 병기 진 카마엘을 창조하였다.</p>
                    <p>하지만 너무 완벽한 존재였던 진 카마엘은 전투병기로서의 실험을 거부하였고, 그랑카인의 도움으로 영혼의 섬에서 은둔 생활을 시작한다. </p>
                    <p>시간이 흘러, 오만의 탑에 봉인되어 있던 바이움은 폭주하였고 모든 종족의 가장 강한 용사들로 구성된 토벌단이 바이움을 막아내려 하지만 역부족이었다.</p>
                    <p>이때, 그랑카인의 화신과 함께 진 카마엘이 등장하여 토벌단의 앞에 서서 바이움에 함께 대항하기 시작했고,</p>
                    <p>그 모습을 지켜본 토벌단은 그들을 잊혀진 하나의 종족으로 인정하게 되는데... </p>
                </div>
            </div>
        </section>
    </transition>
</template>
<script>
    import BasePage from "./mixins/basePage.js";
    import {rePostionContents, reSizeBackground} from '@/utils/cavasResize';
    import canvasObjPosition from '@/utils/canvasObjPosition';
    //import SnowParticle from '@/utils/SnowParticle';

    export default {
        name: "story",
        mixins: [BasePage],
        data() {
            return {
                name: "story",
                contentData: [
                    {type: "bg", source: this.$staticUrl + "img/bg_2.jpg", objName: "bg"},
                    {type: 'bgChrCon'},
                    {type: 'bgCover', source: this.$staticUrl + "img/bg_2_cover.png"}
                ],
                mouseX:0,
                mouseY:0,
                isMouseMove:false
            };
        },
        methods: {
            canvasSet() {
                this.baseCavasSet(this.contentData);

                this.cvObj.chr1Con = new PIXI.Container();
                this.cvObj.bgChrCon.addChild(this.cvObj.chr1Con);
                this.cvObj.chr1 = new PIXI.Sprite.fromImage(this.$staticUrl+'img/obj_2_1.png');
                canvasObjPosition(this.cvObj.chr1, this.cvObj.chr1Con, this.documentSetSize.width/2-206, 2);

                this.cvObj.chr2Con = new PIXI.Container();
                this.cvObj.bgChrCon.addChild(this.cvObj.chr2Con);
                this.cvObj.chr2 = new PIXI.Sprite.fromImage(this.$staticUrl+'img/obj_2_2.png');
                canvasObjPosition(this.cvObj.chr2, this.cvObj.chr2Con, this.documentSetSize.width/2+138, 0);


                this.cvObj.txtTitleCon = new PIXI.Container();
                this.cvObj.con.addChild(this.cvObj.txtTitleCon);
                this.cvObj.txtTitle = new PIXI.Sprite.fromImage(this.$staticUrl+'img/txt_2_tit.png');
                canvasObjPosition(this.cvObj.txtTitle, this.cvObj.txtTitleCon, this.contentSize.w/2, 278);
                this.cvObj.txtTitleLineCon = new PIXI.Container();
                this.cvObj.con.addChild(this.cvObj.txtTitleLineCon);
                this.cvObj.txtTitleLine = new PIXI.Sprite.fromImage(this.$staticUrl+'img/txt_2_tit_line.png');
                canvasObjPosition(this.cvObj.txtTitleLine, this.cvObj.txtTitleLineCon, this.contentSize.w/2, 359);

                this.cvObj.txt1Con = new PIXI.Container();
                this.cvObj.con.addChild(this.cvObj.txt1Con);
                this.cvObj.txt1 = new PIXI.Sprite.fromImage(this.$staticUrl+'img/txt_2_txt_1.png');
                canvasObjPosition(this.cvObj.txt1, this.cvObj.txt1Con, this.contentSize.w/2, 395);

                this.cvObj.txt2Con = new PIXI.Container();
                this.cvObj.con.addChild(this.cvObj.txt2Con);
                this.cvObj.txt2 = new PIXI.Sprite.fromImage(this.$staticUrl+'img/txt_2_txt_2.png');
                canvasObjPosition(this.cvObj.txt2, this.cvObj.txt2Con, this.contentSize.w/2, 481);

                this.cvObj.txt3Con = new PIXI.Container();
                this.cvObj.con.addChild(this.cvObj.txt3Con);
                this.cvObj.txt3 = new PIXI.Sprite.fromImage(this.$staticUrl+'img/txt_2_txt_3.png');
                canvasObjPosition(this.cvObj.txt3, this.cvObj.txt3Con, this.contentSize.w/2, 566);

                this.cvObj.txt4Con = new PIXI.Container();
                this.cvObj.con.addChild(this.cvObj.txt4Con);
                this.cvObj.txt4 = new PIXI.Sprite.fromImage(this.$staticUrl+'img/txt_2_txt_4.png');
                canvasObjPosition(this.cvObj.txt4, this.cvObj.txt4Con, this.contentSize.w/2, 679);

                this.cvObj.txt5Con = new PIXI.Container();
                this.cvObj.con.addChild(this.cvObj.txt5Con);
                this.cvObj.txt5 = new PIXI.Sprite.fromImage(this.$staticUrl+'img/txt_2_txt_5.png');
                canvasObjPosition(this.cvObj.txt5, this.cvObj.txt5Con, this.contentSize.w/2, 763);

                //let snows = new SnowParticle(0, 0);

                this.canvas.ticker.add(()=> {
                    if(!this.isMouseMove)return;
                    let centerNum = this.documentSetSize.width/2;
                    let targetX = (this.mouseX);
                    let chr1TargetX = (centerNum - Math.abs(targetX)/10 - 206);
                    let chr2TargetX = (centerNum - Math.abs(targetX)/-10 + 138);
                    let bgAlpha = this.mouseY / this.documentSetSize.height*0.2 + 0.8;
                    this.cvObj.chr1.x += (chr1TargetX - this.cvObj.chr1.x) * 0.003;
                    this.cvObj.chr2.x += (chr2TargetX - this.cvObj.chr2.x) * 0.003;
                    //this.cvObj.bgCover.alpha += (bgAlpha - this.cvObj.bgCover.alpha) * 0.05
                });



            },
            enter(el, done) {
                this.baseEnter();
                this.canvasSet();
                this.baseEnterMotion(el, done, this.contentData);

                this.enterMotion
                    .fromTo(this.cvObj.chr1, 1.5, {pixi: { brightness: 0,  blur: 10}}, { pixi: { brightness: 1, blur: 0},ease:Power0.easeNone}, 'bgMotionEnd-=0.2')
                    .fromTo(this.cvObj.chr1Con, 1.5, {pixi: {y:152, alpha:0}}, { pixi: {y:52, alpha:1},ease:Sine.easeOut}, 'bgMotionEnd-=0.2')
                    .fromTo(this.cvObj.chr2, 1.5, {pixi: { brightness: 0,  blur: 10}}, { pixi: { brightness: 1, blur: 0},ease:Power0.easeNone}, 'bgMotionEnd-=0.2')
                    .fromTo(this.cvObj.chr2Con, 1.5, {pixi: {y:166, alpha:0}}, { pixi: {y:66, alpha:1},ease:Sine.easeOut, onComplete:()=>{this.mouseMoveSet();}}, 'bgMotionEnd-=0.2')
                    .fromTo(this.cvObj.bgCover, 2, {pixi: { alpha: 0.2}}, { pixi: { alpha: 1},ease:Power0.easeNone}, 'bgMotionEnd+=0')
                    .fromTo(this.cvObj.txtTitleCon, 1.3, {pixi: { brightness: 3}}, { pixi: { brightness: 1},ease:Power0.easeNone}, 'bgMotionEnd-=0.5')
                    .fromTo(this.cvObj.txtTitle, 1, {pixi: { alpha: 0}}, { pixi: { alpha: 1},ease:Power0.easeNone}, 'bgMotionEnd-=0.5')
                    .fromTo(this.cvObj.txtTitleLine, 0.5, {pixi: { alpha: 0, scale:0}}, {pixi:{scale:1, alpha:1}, ease:Back.easeOut}, 'bgMotionEnd+=0.7')
                    .fromTo(this.cvObj.txt1, 1, {pixi: { alpha: 0, scale:0.1}}, {pixi:{scale:1, alpha:1}, ease:Sine.easeOut}, 'bgMotionEnd+=0.9')
                    .fromTo(this.cvObj.txt1Con, 1, {pixi: { blurX: 50}}, {pixi:{blurX:0}}, 'bgMotionEnd+=0.9')
                    .fromTo(this.cvObj.txt2, 1,{pixi: { alpha: 0, scale:0.1}},  {pixi:{scale:1, alpha:1}, ease:Sine.easeOut}, 'bgMotionEnd+=1.3')
                    .fromTo(this.cvObj.txt2Con, 1,{pixi: { blurX: 50}},  {pixi:{blurX:0}}, 'bgMotionEnd+=1.3')
                    .fromTo(this.cvObj.txt3, 1,{pixi: { alpha: 0, scale:0.1}},  {pixi:{scale:1, alpha:1}, ease:Sine.easeOut}, 'bgMotionEnd+=1.6')
                    .fromTo(this.cvObj.txt3Con, 1,{pixi: { blurX: 50}},  {pixi:{blurX:0}}, 'bgMotionEnd+=1.6')
                    .fromTo(this.cvObj.txt4, 1,{pixi: { alpha: 0, scale:0.1}},  {pixi:{scale:1, alpha:1}, ease:Sine.easeOut}, 'bgMotionEnd+=1.9')
                    .fromTo(this.cvObj.txt4Con, 1,{pixi: { blurX: 50}},  {pixi:{blurX:0}}, 'bgMotionEnd+=1.9')
                    .fromTo(this.cvObj.txt5, 1,{pixi: { alpha: 0, scale:0.1}},  {pixi:{scale:1, alpha:1}, ease:Sine.easeOut}, 'bgMotionEnd+=2.2')
                    .fromTo(this.cvObj.txt5Con, 1,{pixi: { blurX: 50}},  {pixi:{blurX:0}}, 'bgMotionEnd+=2.2')
                this.enterMotion.play();
            },
            leave(el, done) {
                if (this.enterMotion) this.enterMotion.pause();
                this.baseLeaveMotion(el, done);
            },
            mouseMoveSet(){
                this.isMouseMove = true;
                window.addEventListener("mousemove", this.mouseMove);
            },
            mouseMove(e){
                this.mouseX = e.clientX;
                this.mouseY = e.clientY;
            },
            resize(){
                this.documentSetSize.width =  document.querySelector('.container').clientWidth;
                this.documentSetSize.height = document.querySelector('.container').clientHeight;
                if(!this.canvas)return;
                reSizeBackground(this.cvObj.bg, this.documentSetSize.width, this.documentSetSize.height);
                reSizeBackground(this.cvObj.bgCover, this.documentSetSize.width, this.documentSetSize.height);
                rePostionContents(this.cvObj.con, this.documentSetSize.width, this.documentSetSize.height, this.contentSize.w, this.contentSize.h, true);

                this.cvObj.chr1.x = this.documentSetSize.width/2-206;
                this.cvObj.chr2.x = this.documentSetSize.width/2+138;

                this.canvas.renderer.resize(this.documentSetSize.width, this.documentSetSize.height);

            }
        }
    };
</script>

